export const commonComponentsResources = {
  "zh-CN": {
    common: {
      onboarding: {
        progressSaveFailed: "暂时无法保存引导进度，请稍后重试",
      },
      sharedComponents: {
        formulaSymbols: {
          tabs: { symbols: "公式符号", templates: "公式模板" },
          categories: {
            common: "常用符号", greek: "希腊字母", fraction: "分数微分", root: "根式指标", limit: "极限对数",
            trig: "三角函数", integral: "积分运算", large: "大型运算", bracket: "括号取整", matrix: "数组矩阵"
          },
          subcategories: {
            binaryRelations: "二元关系符", arrows: "箭头符号", otherSymbols: "其他符号", uppercase: "大写", lowercase: "小写",
            differential: "微分", derivatives: "导数", modularArithmetic: "模算数", scripts: "上下标", accents: "重音符及其他",
            logarithms: "对数指数", bounds: "界限", other: "其他"
          },
          templateCategories: {
            functions: "函数", fractions: "分数根号", matrices: "矩阵数组", integrals: "积分", summations: "求和连乘",
            accents: "修饰符号", chemistry: "化学公式", physics: "物理公式"
          },
          templates: {
            log: "对数函数", ln: "自然对数", sin: "正弦函数", cos: "余弦函数", tan: "正切函数", exp: "指数函数",
            frac: "分数", dfrac: "大分数", sqrt: "根号", nthroot: "n 次根号", binom: "二项式",
            cases_custom: "分段函数", matrix_custom: "自定义矩阵", matrix2_pm: "2×2 圆括号", matrix3_pm: "3×3 圆括号",
            vec_row: "行向量", vec_col: "列向量", int: "定积分", iint: "二重积分", oint: "环路积分", iiint: "三重积分",
            sum: "求和", prod: "连乘", coprod: "余积", lim: "极限", hat: "上帽", bar: "上横", vec: "向量",
            dot: "上点", ddot: "双点", tilde: "波浪", overline: "上划线", underline: "下划线", ce: "化学式",
            ce_eq: "化学方程", velocity: "速度", accel: "加速度", newton: "牛顿第二定律", energy: "动能"
          },
          symbolDescriptions: {
            lineBreak: "换行", wideSpace: "宽空格", doubleWideSpace: "双宽空格", differential: "微分 d", partialDerivative: "偏导",
            gradient: "梯度", pointDerivative: "点导", doublePointDerivative: "双点导", slashNegation: "斜杠否定",
            unframed: "无框", array: "数组", adaptiveDelimiter: "自适应 {{delimiter}}"
          },
          customSize: "自定义尺寸", custom: "自定义"
        },
        formulaEditor: {
          toolbar: {
            text: "文本 \\text{}", bold: "加粗 \\mathbf{}", italic: "斜体 \\mathit{}", clearFormat: "清除格式",
            textPlaceholder: "文本", boldPlaceholder: "粗体", italicPlaceholder: "斜体",
            clear: "清除", environment: "环境 aligned", environmentAction: "环境", wrap: "括号 \\left( \\right)",
            wrapAction: "包裹", undo: "撤销 (Ctrl+Z)", redo: "重做 (Ctrl+Y)"
          },
          latexPlaceholder: "输入 LaTeX 公式，如 \\frac{a}{b} = c^2",
          mathTypeNeedsModule: "MathType 可视化模式需要加载 mathlive 模块。",
          mathTypeFallback: "如未自动加载，请使用 LaTeX 模式。", switchToLatex: "切回 LaTeX",
          preview: "公式预览：", error: "公式错误"
        },
        passwordConfirm: {
          title: "密码确认", message: "请输入当前用户密码以继续操作", confirm: "确认", missingPassword: "请输入密码",
          expired: "登录已过期，请重新登录", incorrect: "密码错误", passwordPlaceholder: "输入密码", showPassword: "显示密码",
          hidePassword: "隐藏密码", cancel: "取消"
        },
        blockActions: {
          downloadImage: "下载图片", downloadSvg: "下载 SVG", dataDownload: "数据 · {{label}}",
          copyBlock: "复制此区块（Markdown 原文）", editImageDescription: "编辑图片描述", copyTable: "复制表格",
          editTable: "编辑表格", copyFormula: "复制公式", history: "修订历史", editBlock: "编辑此区块", download: "下载"
        },
        blockEdit: {
          types: {
            text: "文本", title: "标题", list: "列表", header: "页眉", footer: "页脚", table: "表格", formula: "公式",
            image: "图片描述", chart: "图表描述", code: "代码"
          },
          title: "{{label}}编辑", close: "关闭", copy: "复制", saveShortcut: "Ctrl+Enter 保存", cancel: "取消", save: "保存"
        },
        markdownEditor: {
          toolbar: {
            paragraph: "正文", heading1: "标题1", heading2: "标题2", heading3: "标题3",
            bold: "加粗", italic: "斜体", strike: "删除线", superscript: "上标", subscript: "下标",
            inlineCode: "行内代码", codeBlock: "代码块", unorderedList: "无序列表", orderedList: "有序列表",
            quote: "引用", horizontalRule: "分割线", table: "表格", link: "链接", uploadImage: "上传图片",
            imageUnavailable: "图片(需上传能力)", more: "更多", undo: "撤销 (Ctrl+Z)", redo: "重做 (Ctrl+Y)",
            backToEdit: "返回编辑", previewMarkdown: "预览 Markdown", tableColumn1: "列1", tableColumn2: "列2"
          },
          placeholders: {
            bold: "粗体", italic: "斜体", strike: "删除线", superscript: "上标", subscript: "下标",
            inlineCode: "代码", codeBlock: "代码块", linkText: "链接文本", imageDescription: "图片描述"
          },
          emptyPreview: "暂无内容", editorPlaceholder: "编辑 Markdown 内容（Ctrl+Enter 保存，Esc 取消）"
        },
        citationSourceList: {
          referenceSources: "引用来源", retrievedSources: "检索来源", sourceVersions: "{{count}} 个来源版本",
          expandReferences: "展开其余 {{count}} 个引用编号", collapse: "收起"
        },
        citationMarkers: { invalidCitation: "[引用 {{index}} 不可用]", invalidImage: "[图片来源 {{index}} 不可用]" },
        blockContentCards: {
          imageDescription: "图片描述",
          source: { manual: "手动输入", ai_caption: "AI Caption", img_ocr: "OCR", automatic: "自动结果" }
        },
        tableGrid: {
          insertRowBelow: "在下方插入行", insertColumnRight: "在右侧插入列", deleteRow: "删除行", deleteColumn: "删除列",
          mergeCells: "合并单元格", splitCell: "拆分单元格", convertToHeader: "转为表头"
        },
        modelSelect: {
          placeholder: "选择模型", defaultModel: "默认模型", defaultModelWithProvider: "默认模型（{{provider}} / {{model}}）",
          loading: "加载可用模型…", embeddingDimension: "（{{dimension}} 维）", empty: "暂无可用模型"
        },
        authImage: { unavailable: "图片或引用版本暂不可读取。", retry: "重试" },
        casesSizePicker: { title: "选择分段数", segmentUnit: "段" },
        markdownProvider: { imageUnavailable: "图片来源暂不可读取" },
        matrixSizePicker: {
          title: "选择矩阵尺寸", hoverHint: "悬停选择", bracketLabel: "括号:",
          styles: { parentheses: "圆括号", squareBrackets: "方括号", absoluteValue: "绝对值", braces: "花括号", norm: "范数" }
        },
        parseLogTooltip: {
          phases: {
            download: "下载", parse: "解析", parseChunk: "分片解析", chunking: "分块", embedding: "向量化", indexing: "索引写入",
            metadata: "元数据", treeBuild: "知识树", chapterDetect: "章节检测", vlmProcess: "VLM 处理", complete: "完成",
            start: "开始", wait: "等待解析", fetch: "获取内容", tree: "文档树", chunk: "分块", embed: "生成向量",
            persist: "写入", rechunk: "重新分块"
          },
          waiting: "等待日志...", empty: "暂无解析日志", connecting: "连接中...", logCount: "{{count}} 条日志",
          failed: "失败", warning: "警告", completed: "已完成"
        },
        demoSetup: {
          status: { ready: "已就绪", failed: "失败", processing: "解析中", queued: "排队中" },
          error: "演示环境准备失败，可稍后在行业市场重试", title: "正在为你准备演示环境",
          description: "我们会在你的团队中添加示例知识库（{{knowledgeBase}}）和可直接对话的产品助手。解析完成后即可体验知识库问答与引用溯源。",
          seeding: "正在注入示例知识库…", importing: "正在导入演示文档…",
          partialFailure: "部分文档解析失败不影响体验，可在知识库中手动重试。", skip: "跳过，稍后体验", ready: "演示环境已就绪"
        },
        welcomeDialog: {
          close: "关闭欢迎介绍", title: "欢迎使用 inFab",
          description: "把企业的文档与数据接入大模型：让团队用自然语言完成知识检索、内容生产与数据分析。底层引擎与中科院物理所、南京大学等机构与企业所使用的内核一致，支持私有化部署。",
          demoIntro: "建议先体验预置的演示环境：我们会为你准备一个示例知识库和产品助手，几分钟后即可上手。",
          capabilities: {
            knowledgeBase: "知识库问答：回答附引用，可溯源到原文", industryMarket: "行业市场：按行业预置智能体与数据模板",
            documentAnalysis: "文档分析：拖入文档即时总结与提取", dataCenter: "数据中心：自然语言查询与结构化抽取"
          },
          startDemo: "一键体验演示环境", expertConsultation: "获取 1V1 咨询", qrAlt: "扫码预约专家咨询",
          expertEnabled: "扫码联系专家，获取业务接入与部署建议。",
          expertDisabled: "开始使用后，可随时通过右下角帮助助手预约专家获取 1V1 支持。",
          openReservation: "打开预约入口", saveQr: "保存二维码", contact: "{{label}}：{{value}}"
        },
        helpAssistantTour: {
          title: "需要帮助时，点这里", description: "你可以在全局帮助助手中询问帮助文档，也可预约专家获取 1V1 支持。",
          skip: "跳过", openAssistant: "打开助手"
        },
        secondaryNav: { ariaLabel: "{{title}}导航" },
        pendingFrame: { loading: "正在加载", knowledgeBase: "知识库", documents: "文档", semanticPlatform: "知识本体", dataCenter: "数据中心", tenantSettings: "团队设置", settings: "系统设置" },
        packDelete: {
          title: "删除确认", confirmName: "确定要删除「{{name}}」吗？", cascadeWarning: "该目录下包含子目录，删除将同时删除所有子目录。",
          cancel: "取消", cascadeDelete: "级联删除", delete: "删除"
        },
        fileArtifactPreview: { loading: "正在加载预览…", unsupported: "{{name}} 暂不支持在线预览", download: "下载文件" },
        previewErrorBoundary: {
          failed: "预览加载失败",
          missingSource: "源文件可能已被删除或存储中缺失，可返回对话查看其他引用",
          retry: "重试"
        },
        tableDataGrid: {
          empty: "该表没有数据行",
          column: "列 {{index}}",
          truncatedRows: "仅显示前 {{shown}} 行（共 {{total}} 行）"
        },
        confirmDialog: { confirm: "确认", cancel: "取消" }
      }
    }
  },
  "en-US": {
    common: {
      onboarding: {
        progressSaveFailed: "Could not save onboarding progress. Try again shortly.",
      },
      sharedComponents: {
        formulaSymbols: {
          tabs: { symbols: "Symbols", templates: "Templates" },
          categories: {
            common: "Common Symbols", greek: "Greek Letters", fraction: "Fractions and Derivatives", root: "Roots and Scripts",
            limit: "Limits and Logarithms", trig: "Trigonometric Functions", integral: "Integrals", large: "Large Operators",
            bracket: "Brackets and Floors", matrix: "Arrays and Matrices"
          },
          subcategories: {
            binaryRelations: "Binary Relations", arrows: "Arrows", otherSymbols: "Other Symbols", uppercase: "Uppercase", lowercase: "Lowercase",
            differential: "Differentials", derivatives: "Derivatives", modularArithmetic: "Modular Arithmetic", scripts: "Superscripts and Subscripts",
            accents: "Accents and Other", logarithms: "Logarithms and Exponents", bounds: "Bounds", other: "Other"
          },
          templateCategories: {
            functions: "Functions", fractions: "Fractions and Roots", matrices: "Matrices and Arrays", integrals: "Integrals",
            summations: "Summations and Products", accents: "Accents", chemistry: "Chemical Formulas", physics: "Physics Formulas"
          },
          templates: {
            log: "Logarithm", ln: "Natural Logarithm", sin: "Sine", cos: "Cosine", tan: "Tangent", exp: "Exponential",
            frac: "Fraction", dfrac: "Display Fraction", sqrt: "Square Root", nthroot: "Nth Root", binom: "Binomial",
            cases_custom: "Piecewise Function", matrix_custom: "Custom Matrix", matrix2_pm: "2×2 Parentheses", matrix3_pm: "3×3 Parentheses",
            vec_row: "Row Vector", vec_col: "Column Vector", int: "Definite Integral", iint: "Double Integral", oint: "Contour Integral", iiint: "Triple Integral",
            sum: "Sum", prod: "Product", coprod: "Coproduct", lim: "Limit", hat: "Hat", bar: "Overbar", vec: "Vector",
            dot: "Dot", ddot: "Double Dot", tilde: "Tilde", overline: "Overline", underline: "Underline", ce: "Chemical Formula",
            ce_eq: "Chemical Equation", velocity: "Velocity", accel: "Acceleration", newton: "Newton's Second Law", energy: "Kinetic Energy"
          },
          symbolDescriptions: {
            lineBreak: "Line Break", wideSpace: "Wide Space", doubleWideSpace: "Double Wide Space", differential: "Differential d", partialDerivative: "Partial Derivative",
            gradient: "Gradient", pointDerivative: "Dot Derivative", doublePointDerivative: "Double-Dot Derivative", slashNegation: "Slash Negation",
            unframed: "Unframed", array: "Array", adaptiveDelimiter: "Adaptive {{delimiter}}"
          },
          customSize: "Custom Size", custom: "Custom"
        },
        formulaEditor: {
          toolbar: {
            text: "Text \\text{}", bold: "Bold \\mathbf{}", italic: "Italic \\mathit{}", clearFormat: "Clear Formatting",
            textPlaceholder: "Text", boldPlaceholder: "Bold", italicPlaceholder: "Italic",
            clear: "Clear", environment: "Environment aligned", environmentAction: "Environment", wrap: "Brackets \\left( \\right)",
            wrapAction: "Wrap", undo: "Undo (Ctrl+Z)", redo: "Redo (Ctrl+Y)"
          },
          latexPlaceholder: "Enter a LaTeX formula, e.g. \\frac{a}{b} = c^2",
          mathTypeNeedsModule: "MathType visual mode requires the mathlive module.",
          mathTypeFallback: "If it does not load automatically, use LaTeX mode.", switchToLatex: "Switch to LaTeX",
          preview: "Formula Preview:", error: "Formula Error"
        },
        passwordConfirm: {
          title: "Confirm Password", message: "Enter your current password to continue", confirm: "Confirm", missingPassword: "Enter your password",
          expired: "Your session has expired. Please sign in again.", incorrect: "Incorrect password", passwordPlaceholder: "Enter password",
          showPassword: "Show password", hidePassword: "Hide password", cancel: "Cancel"
        },
        blockActions: {
          downloadImage: "Download Image", downloadSvg: "Download SVG", dataDownload: "Data · {{label}}",
          copyBlock: "Copy Block (Markdown Source)", editImageDescription: "Edit Image Description", copyTable: "Copy Table",
          editTable: "Edit Table", copyFormula: "Copy Formula", history: "Revision History", editBlock: "Edit This Block", download: "Download"
        },
        blockEdit: {
          types: {
            text: "Text", title: "Title", list: "List", header: "Header", footer: "Footer", table: "Table", formula: "Formula",
            image: "Image Description", chart: "Chart Description", code: "Code"
          },
          title: "Edit {{label}}", close: "Close", copy: "Copy", saveShortcut: "Ctrl+Enter to save", cancel: "Cancel", save: "Save"
        },
        markdownEditor: {
          toolbar: {
            paragraph: "Body", heading1: "Heading 1", heading2: "Heading 2", heading3: "Heading 3",
            bold: "Bold", italic: "Italic", strike: "Strikethrough", superscript: "Superscript", subscript: "Subscript",
            inlineCode: "Inline code", codeBlock: "Code block", unorderedList: "Bulleted list", orderedList: "Numbered list",
            quote: "Quote", horizontalRule: "Horizontal rule", table: "Table", link: "Link", uploadImage: "Upload image",
            imageUnavailable: "Image (upload unavailable)", more: "More", undo: "Undo (Ctrl+Z)", redo: "Redo (Ctrl+Y)",
            backToEdit: "Back to edit", previewMarkdown: "Preview Markdown", tableColumn1: "Column 1", tableColumn2: "Column 2"
          },
          placeholders: {
            bold: "Bold text", italic: "Italic text", strike: "Strikethrough", superscript: "Superscript", subscript: "Subscript",
            inlineCode: "Code", codeBlock: "Code block", linkText: "Link text", imageDescription: "Image description"
          },
          emptyPreview: "No content", editorPlaceholder: "Edit Markdown content (Ctrl+Enter to save, Esc to cancel)"
        },
        citationSourceList: {
          referenceSources: "References", retrievedSources: "Retrieved sources", sourceVersions: "{{count}} source versions", sourceVersions_one: "{{count}} source version",
          sourceVersions_other: "{{count}} source versions", expandReferences: "Show {{count}} more citation numbers", collapse: "Collapse"
        },
        citationMarkers: { invalidCitation: "[Citation {{index}} is unavailable]", invalidImage: "[Image source {{index}} is unavailable]" },
        blockContentCards: {
          imageDescription: "Image description",
          source: { manual: "Manual input", ai_caption: "AI caption", img_ocr: "OCR", automatic: "Automatic result" }
        },
        tableGrid: {
          insertRowBelow: "Insert Row Below", insertColumnRight: "Insert Column Right", deleteRow: "Delete Row", deleteColumn: "Delete Column",
          mergeCells: "Merge Cells", splitCell: "Split Cell", convertToHeader: "Convert to Header"
        },
        modelSelect: {
          placeholder: "Select a model", defaultModel: "Default Model", defaultModelWithProvider: "Default Model ({{provider}} / {{model}})",
          loading: "Loading available models…", embeddingDimension: "({{dimension}} dimensions)", empty: "No models available"
        },
        authImage: { unavailable: "The image or cited revision is temporarily unavailable.", retry: "Retry" },
        casesSizePicker: { title: "Select Number of Cases", segmentUnit: "cases" },
        markdownProvider: { imageUnavailable: "Image source is temporarily unavailable" },
        matrixSizePicker: {
          title: "Select Matrix Size", hoverHint: "Hover to select", bracketLabel: "Brackets:",
          styles: { parentheses: "Parentheses", squareBrackets: "Square Brackets", absoluteValue: "Absolute Value", braces: "Braces", norm: "Norm" }
        },
        parseLogTooltip: {
          phases: {
            download: "Download", parse: "Parse", parseChunk: "Parse Chunks", chunking: "Chunk", embedding: "Embedding", indexing: "Write Index",
            metadata: "Metadata", treeBuild: "Build Knowledge Tree", chapterDetect: "Detect Chapters", vlmProcess: "VLM Processing", complete: "Complete",
            start: "Start", wait: "Waiting for Parse", fetch: "Fetch Content", tree: "Document Tree", chunk: "Chunk", embed: "Generate Embeddings",
            persist: "Write", rechunk: "Rechunk"
          },
          waiting: "Waiting for logs...", empty: "No parsing logs", connecting: "Connecting...", logCount: "{{count}} log entries",
          failed: "Failed", warning: "Warning", completed: "Completed"
        },
        demoSetup: {
          status: { ready: "Ready", failed: "Failed", processing: "Parsing", queued: "Queued" },
          error: "Could not prepare the demo environment. Try again later from the Industry Market.", title: "Preparing Your Demo Environment",
          description: "We’ll add a sample knowledge base ({{knowledgeBase}}) and a product assistant you can chat with to your team. Once processing finishes, try knowledge Q&A with traceable citations.",
          seeding: "Adding the sample knowledge base…", importing: "Importing demo documents…",
          partialFailure: "Some documents failed to parse. You can retry them manually in the knowledge base.", skip: "Skip for now", ready: "Demo environment is ready"
        },
        welcomeDialog: {
          close: "Close Welcome Introduction", title: "Welcome to inFab",
          description: "Connect your company's documents and data to large language models so your team can search knowledge, create content, and analyze data in natural language. The underlying engine is used by organizations including 中科院物理所 and 南京大学, and supports private deployment.",
          demoIntro: "Start with the prepared demo environment. We’ll create a sample knowledge base and product assistant so you can get started in minutes.",
          capabilities: {
            knowledgeBase: "Knowledge Q&A: answers include citations linked to the source", industryMarket: "Industry Market: industry-specific agents and data templates",
            documentAnalysis: "Document Analysis: drop in files for instant summaries and extraction", dataCenter: "Data Center: natural-language queries and structured extraction"
          },
          startDemo: "Try the Demo Environment", expertConsultation: "Talk to an Expert", qrAlt: "Scan to schedule an expert consultation",
          expertEnabled: "Scan to contact an expert for integration and deployment advice.",
          expertDisabled: "After you get started, use the Help Assistant in the lower-right corner to book one-on-one support.",
          openReservation: "Open Booking Page", saveQr: "Save QR Code", contact: "{{label}}: {{value}}"
        },
        helpAssistantTour: {
          title: "Click here when you need help", description: "Ask the Help Assistant for help articles or book one-on-one support from an expert.",
          skip: "Skip", openAssistant: "Open Assistant"
        },
        secondaryNav: { ariaLabel: "{{title}} navigation" },
        pendingFrame: { loading: "Loading", knowledgeBase: "Knowledge Base", documents: "Documents", semanticPlatform: "Knowledge Model", dataCenter: "Data Center", tenantSettings: "Team Settings", settings: "System Settings" },
        packDelete: {
          title: "Confirm Deletion", confirmName: "Delete “{{name}}”?", cascadeWarning: "This directory contains subdirectories. Deleting it will also delete all subdirectories.",
          cancel: "Cancel", cascadeDelete: "Delete Recursively", delete: "Delete"
        },
        fileArtifactPreview: { loading: "Loading preview…", unsupported: "{{name}} cannot be previewed online", download: "Download File" },
        previewErrorBoundary: {
          failed: "Preview failed to load",
          missingSource: "The source file may have been deleted or removed from storage. Return to the conversation to view another citation.",
          retry: "Retry"
        },
        tableDataGrid: {
          empty: "This table has no data rows",
          column: "Column {{index}}",
          truncatedRows: "Showing the first {{shown}} of {{total}} rows"
        },
        confirmDialog: { confirm: "Confirm", cancel: "Cancel" }
      }
    }
  }
} as const;
